import type { ReactNode } from "react";
import { useBetterAuthSessionBootstrap } from "hooks/auth/useBetterAuthSessionBootstrap";

type BetterAuthSessionBootstrapProps = {
  children: ReactNode;
};

/**
 * Runs Better Auth session restore as a side effect only.
 * Always renders children so ErrorHandler / auth maintenance UI can mount
 * during web-scoped maintenance (get-session is not allowlisted and may 503).
 */
export const BetterAuthSessionBootstrap = ({ children }: BetterAuthSessionBootstrapProps) => {
  useBetterAuthSessionBootstrap();
  return children;
};
